import { IExecutionOptions, IQueryOptions } from '../../models/query';
import { BaseTransform } from './BaseTransform';
import { isArrayLike } from '../../utils/isArrayLike';
import { ConditionalHelper } from '../../helpers/ConditionalHelper';

export class FilterTransform extends BaseTransform {
	execute(queryResponse: any[], queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		let response: any[] = queryResponse;
		const { conditional: filterConditional } = this.options;
		if (queryResponse && isArrayLike(queryResponse) && filterConditional) {
			const conditionalHelper = new ConditionalHelper(filterConditional, this.translationHelper);
			response = queryResponse.filter((record) => {
				return conditionalHelper.matches(record);
			});
		}
		return response;
	}
}